import { getStageClasses } from '@/utils/stages';

interface StatusBadgeProps {
  stage: string;
  className?: string;
}

export function StatusBadge({ stage, className = '' }: StatusBadgeProps) {
  const colors = getStageClasses(stage);
  return (
    <span
      className={`px-2.5 py-1 text-xs font-bold rounded-full ${colors} ${className}`}
    >
      {stage}
    </span>
  );
}
